import React from "react";
import { PageHero, CTA } from "@/components/PageHero";
import { INDUSTRIES } from "@/data/site";
import { useSEO } from "@/hooks/useSEO";

export default function Industries() {
  useSEO({
    title: "Industries We Serve — Easyworks Industries",
    description: "Customized technology solutions for Healthcare, Education, Real Estate, Construction, Manufacturing, NGOs, Hospitality, Retail, Logistics and Startups.",
  });
  return (
    <div data-testid="industries-page">
      <PageHero title="Industries We Serve" subtitle="Customized technology solutions for every industry we work with." />
      <section className="py-20">
        <div className="container mx-auto max-w-7xl px-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {INDUSTRIES.map((ind) => {
            const Icon = ind.icon;
            return (
              <div key={ind.key} className="p-6 rounded-xl border border-slate-200 bg-white hover:border-blue-200 hover:shadow-md hover:-translate-y-1 transition-all duration-300 text-center" data-testid={`industry-detail-${ind.key}`}>
                <div className="w-14 h-14 mx-auto rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center mb-3">
                  <Icon className="w-7 h-7 text-[#2563EB]" strokeWidth={1.6} />
                </div>
                <div className="font-semibold text-slate-900 text-[15px]" style={{ fontFamily: "Outfit" }}>{ind.name}</div>
                <div className="text-[12px] text-slate-500 mt-1">Tailored solutions</div>
              </div>
            );
          })}
        </div>
      </section>
      <CTA />
    </div>
  );
}
